<template>
  <div class="container main has-submenu" style="margin: auto;" id="top">
    <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="panel panel-info">
      <div class="wrapper">
        <div class="row">
        <!-- left column -->
        <div class="col-md-4 col-sm-6 col-xs-12">
          <vue-clip :options="options" :onAddedFile="onAddedFile" :onComplete="onComplete">
            <template slot="clip-uploader-action">
              <div class="fancy-dropzone">
                <img :src="avatarImg" class="img-response avatar img-circle" alt="avatar">
                <div id="drop-zone" :disabled="displayProgressBar"
                  class="dz-message upload-drop-zone img-responsive avatar img-circle img-thumbnail"
                  :class="(displayProgressBar) ? 'blurred': ''"
                >
                  <label>
                    <i class="fa fa-pencil"></i>&nbsp;Change picture
                  </label>
                </div>
              </div>
            </template>

            <template slot="clip-uploader-body" slot-scope="props">
              <div v-if="displayProgressBar"
                class="progress progress-bar-striped progress-bar-animated"
                :class="(props.files[0].status === 'error') ? 'bg-danger' : ''"
                style="height: 4px; border-radius: 0;"
              >
                <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" :style="{width: props.files[0].progress +'%'}">
                  <span class="sr-only">{props.files[0].progress}% complete</span>
                </div>
              </div>

              <div v-if="hasError" class="alert alert-danger alert-dismissable">
                <a class="panel-close close" @click.prevent="dismissErrorAlert">
                  <i class="fa fa-times"></i>
                </a>
                <p>Image upload failed, please try again later.</p>
              </div>

              <div v-if="isSuccess" class="alert alert-success">
                <p>Image upload successful</p>
              </div>
            </template>
          </vue-clip>
        </div>
        <!-- edit form column -->
        <div class="col-md-8 col-sm-6 col-xs-12 personal-info">
        <!-- <div class="alert alert-info alert-dismissable">
            <a class="panel-close close" data-dismiss="alert">×</a>
            <i class="fa fa-coffee"></i>
            This is an <strong>.alert</strong>. Use this to show important messages to the user.
        </div> -->
        <h3>Personal info</h3>
        <form class="form-horizontal form" @submit.prevent="editAccount" role="form">
            <div class="form-group">
            <label class="col-lg-3 control-label">First name:</label>
            <div class="col-lg-8">
                <input class="form-control" v-model="account.firstName" required type="text">
            </div>
            </div>
            <div class="form-group">
            <label class="col-lg-3 control-label">Last name:</label>
            <div class="col-lg-8">
                <input class="form-control" required v-model="account.lastName" type="text">
            </div>
            </div>
            <div class="form-group">
            <label class="col-lg-3 control-label">Phone:</label>
            <div class="col-lg-8">
                <input class="form-control" required v-model="account.phoneNumber" type="text" disabled>
            </div>
            </div>
            <div class="form-group">
            <label class="col-lg-3 control-label">Email:</label>
            <div class="col-lg-8">
                <input class="form-control" required v-model="account.email" type="text">
            </div>
            </div>
            <div class="form-group">
            <label class="col-md-3 control-label"></label>
            <div class="col-md-8">
              <vue-ladda :loading="loading" data-style="expand-right">
                <i class="fa fa-check"></i>
                <span> Save change</span>
              </vue-ladda>
            </div>
            </div>
        </form>
        <h3>Change Password</h3>
        <div v-show="error" class="alert alert-danger alert-dismissable" style="margin-right:20px;">
            <a class="panel-close close" data-dismiss="alert">×</a>
            <i class="fa fa-exclamation-triangle" style="font-size:25px;"></i>
            {{errorMessage}}
        </div>
        <form @submit.prevent="updatePass" class="form-horizontal form">
          <div class="form-group">
            <label class="col-md-3 control-label">Old Password:</label>
            <div class="col-md-8">
                <input class="form-control" value="" v-model="credentials.oldPassword" required type="password"><br>
            </div>
            </div>
            <div class="form-group">
            <label class="col-md-3 control-label">New Password:</label>
            <div class="col-md-8">
                <input class="form-control" v-model="credentials.newPassword" required type="password"><br>
            </div>
            </div>
            <div class="form-group">
            <label class="col-md-3 control-label">Confirm Password:</label>
            <div class="col-md-8">
                <input class="form-control" v-model="credentials.confirmPassword" required type="password"><br>
            </div>
            </div>
            <div class="form-group">
            <label class="col-md-3 control-label"></label>
            <div class="col-md-8">
                <vue-ladda :loading="loading1" data-style="expand-right">
                  <span>Change Password</span>
                </vue-ladda>
            </div>
            </div>
        </form>
        </div>
        </div>  <!-- end row -->
      </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  import {HTTP, accountService} from '../../services/account-services.js'
  import Vue from 'vue'
  import VueClip from 'vue-clip'
  import VueLadda from 'vue-ladda'
  import { default as swal } from 'sweetalert2'
  import { AVATAR_IMG_UPDATED } from '../../events'

  Vue.use(VueClip)
  export default {
    name: 'EditProfile',
    components: {
      'vue-ladda': VueLadda
    },
    data() {
      return {
        account: {},
        hasError: false,
        isSuccess: false,
        displayProgressBar: false,
        avatarImg: null,
        loading: false,
        loading1: false,
        credentials: {},
        error: false,
        errorMessage: 'Password mismatch!',
        options: {
          url: `https://api.haitipay.com/v1/accounts/${localStorage.getItem('userId')}/avatar?access_token=${localStorage.getItem('authToken')}&authorization=J1DWJi6L4710H5opgtgFo40fqQhQTMgwITmOAdPFmj5V70E52cDg478DSdrTy10R`,
          paramName: 'avatar',
          maxFiles: 1
        }
      }
    },
    methods: {
      onAddedFile() {
        if (!this.displayProgressBar) {
          this.displayProgressBar = true
        }
      },
      onComplete(file, result) {
        if (result === 'success') {
          localStorage.setItem('avatarUrl', file.dataUrl)
          this.avatarImg = file.dataUrl
          accountService.$emit(AVATAR_IMG_UPDATED)
          this.isSuccess = true
        }

        setTimeout(() => {
          this.displayProgressBar = false
          if (result !== 'success') {
            this.hasError = true
          }
          this.isSuccess = false
        }, 2500)
      },
      dismissErrorAlert() {
        this.hasError = false
      },
      getAccount() {
        let token = localStorage.getItem('authToken')
        let userId = localStorage.getItem('userId')
        return HTTP.get(`/accounts/${userId}?access_token=${token}`)
      },
      editAccount() {
        this.loading = true
        let token = localStorage.getItem('authToken')
        let userId = localStorage.getItem('userId')
        HTTP.put(`/accounts/${userId}?access_token=${token}`,
          {
            firstName: this.account.firstName,
            lastName: this.account.lastName,
            email: this.account.email
          }
        )
          .then((response) => {
            console.log(response)
            this.loading = false
            swal(
              'Success !',
              'Your account has been updated!!',
              'success'
            )
          }).catch(function(e) {
            console.log(e)
          })
      },
      updatePass() {
        this.loading1 = true
        let token = localStorage.getItem('authToken')
        let userId = localStorage.getItem('userId')
        let oldPassword = this.credentials.oldPassword
        let newPassword = this.credentials.newPassword
        // let confirmPass = this.credentials.confirmPass
        // if (newPassword === confirmPass) {
        // console.log('Changing Pass ...')
        HTTP.post(`/accounts/${userId}/changePassword?access_token=${token}`,
          {
            oldPassword: oldPassword,
            newPassword: newPassword
          }
        ).then((response) => {
          this.loading1 = false
          swal(
            'Success',
            'Your Password has been updated!!',
            'success'
          )
        })
        this.loading1 = false
      }
    },
    beforeMount() {
      if (!localStorage.getItem('authToken')) {
        return this.$router.push('/login')
      }

      let avatarUrl = localStorage.getItem('avatarUrl')
      let defaultAvatarUrl = '/static/img/default_avatar.png'

      if (avatarUrl.length === 0) {
        this.avatarImg = defaultAvatarUrl
      } else {
        this.avatarImg = avatarUrl
      }

      this.getAccount().then((result) => {
        this.account = result.data
      })
    },
    mounted() {
      this.$scrollTo('#top', 1000)
      this.getAccount()
    },
    props: ['loggedIn']
  }
</script>
<style scoped>
.avatar {
  max-width: 60%;
}

.fancy-dropzone {
  width: inherit;
  height: 180px;
  margin-top: 30px;
  margin-bottom: 10px;
  text-align: center !important;
}

.fancy-dropzone img {
  position: absolute;
  margin: auto;
  margin-left: -75px;
  padding: 0;
  width:140px;
  height:140px;
  z-index: 1;
}

@media (max-width: 480px){
  .control-label {
    padding-left: 20px;
  }
  .wrapper{
    margin-left:10px;
    margin-right:10px;
  }
  .form{
    margin-right: 20px;
  }
  #drop-zone{
    margin-right: 20px;
    cursor: pointer;
  }
}
/* layout.css Style */
.upload-drop-zone {
  position: absolute;
  width: 140px;
  height: 140px;
  margin: auto;
  margin-left: -75px;
  padding: 0;
  z-index: 2;
  opacity: 0.1;
  line-height: 100px;
  text-align: center;
  cursor: pointer;
}

.upload-drop-zone label {
  position: relative;
  top: 100px;
  margin: auto;
  padding: 0;
  color: #222222;
  cursor: pointer;
}

.upload-drop-zone.blurred,
.upload-drop-zone:hover {
  background-color: #444444;
  opacity: 0.4;
}

.upload-drop-zone.drop {
  color: #444444;
  border-color: #444444;
}

.ladda-button {
  background: #2bc0e4;
  border: 0;
  padding: 10px 18px;
  font-size: 18px;
  cursor: pointer;
  color: #fff;
  border-radius: 2px;
  border: 1px solid transparent;
  -webkit-appearance: none;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: transparent;
}

.ladda-button:hover {
  background: #2873ac;
}

@media (max-width: 480px) {
  .ladda-button {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Account/EditProfile.vue